import BaseService from '@/services-ts/BaseService'
import type { ICompanySettings } from '@/types/Data/UserAPI'
import type { IPayloadCompanySetting } from '@/types/Request'

export default class EmployeeTypeServices extends BaseService {
  GetEmployeeTypeList() {
    return this.GET<ICompanySettings[]>(this.PATHS.GET_EMPLOYEE_TYPE_LIST)
  }

  CreateEmployeeType(Name: string) {
    return this.POST<ICompanySettings>(this.PATHS.CREATE_EMPLOYEE_TYPE, { Name })
  }

  UpdateEmployeeType(payload: IPayloadCompanySetting) {
    return this.POST<ICompanySettings>(this.PATHS.UPDATE_EMPLOYEE_TYPE, payload)
  }

  DeleteEmployeeType(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_EMPLOYEE_TYPE, { Id })
  }
}
